import { render, staticRenderFns } from "./MenuUno.vue?vue&type=template&id=2b8fbc50"
import script from "./MenuUno.vue?vue&type=script&lang=js"
export * from "./MenuUno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports